import { render, staticRenderFns } from "./ShiftHeader.vue?vue&type=template&id=23e7ec54&"
import script from "./ShiftHeader.vue?vue&type=script&lang=ts&"
export * from "./ShiftHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports